import { getDecodedJwtToken } from '../utils/jwt';

const useRoles = () => {
    const jwt = getDecodedJwtToken();
    const roles = jwt?.roles;
    return roles ?? [];
};

export default useRoles;
